import React from 'react';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import NodeArticlePage from './Page';
import type { NodeArticle } from '../../../types/uncinc_profile/nodes';

interface NodeArticleProps {
  entity: ImmutableEntity<NodeArticle>;
  viewMode: string;
}

const NodeArticleWrapper: React.FC<NodeArticleProps> = ({ entity, viewMode }) => {
  switch (viewMode) {
    default:
      return <NodeArticlePage entity={entity} />;
  }
};

export default NodeArticleWrapper;
